<script setup lang="ts">
  import { IconRadio } from '@/shared/ui';

  defineProps<{
    modelValue: 'upload' | 'url' | undefined;
  }>();

  defineEmits<{
    (e: 'update:modelValue', value: 'upload' | 'url' | undefined): void;
  }>();
</script>

<template>
  <div class="text-sm border-b border-gray-02 py-8 px-6">
    <span class="mb-2 font-semibold"> Escolha entre os modos de envio: </span>

    <div class="flex gap-6 font-medium">
      <IconRadio
        :model-value="modelValue"
        variant="small"
        value="upload"
        label="Upload"
        name="uploadMode"
        @update:model-value="$emit('update:modelValue', $event)"
      />
      <IconRadio
        :model-value="modelValue"
        variant="small"
        value="url"
        label="URL"
        name="uploadMode"
        @update:model-value="$emit('update:modelValue', $event)"
      />
    </div>
  </div>
</template>
